import { render, staticRenderFns } from "./RsaPazienteSocioRiabilitativoPedagogicoEditComponent.vue?vue&type=template&id=765edd49"
import script from "./RsaPazienteSocioRiabilitativoPedagogicoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSocioRiabilitativoPedagogicoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports